
// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Ajusta seg�n lo que realmente tengas disponible
const SUPPORTED_LNGS = ['en', 'es', 'fr'];
const FALLBACK_LNG = 'en';

// Cache simple en memoria para no recargar el mismo JSON
const cache = new Map();

const resolveBaseUrl = () => {
    // En CRA, process.env.PUBLIC_URL existe; en Vite no.
    // Caemos a '' para que /public se sirva en ra�z (/)
    return (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || '';
};

const loadLanguage = async (lng) => {
    try {
        const baseUrl = resolveBaseUrl();
        const url = `${baseUrl}/locales/${lng}.json`;

        if (cache.has(url)) return cache.get(url);

        const response = await fetch(url, { cache: 'no-cache' });
        if (!response.ok) {
            console.error(`[i18n] No se pudo cargar ${url} (status ${response.status})`);
            return {};
        }
        const translations = await response.json();
        cache.set(url, translations);
        return translations;
    } catch (error) {
        console.error('[i18n] Error cargando archivo de idioma:', error);
        return {};
    }
};

const initializeI18n = async () => {
    const nav = (typeof navigator !== 'undefined' && navigator.language) || 'es';
    const detectedLng = (nav.split('-')[0] || 'es').toLowerCase();
    const initialLng = SUPPORTED_LNGS.includes(detectedLng) ? detectedLng : FALLBACK_LNG;

    // Carga el idioma detectado y el fallback para tener �rescate� real de claves
    const [detectedBundle, fallbackBundle] = await Promise.all([
        loadLanguage(initialLng),
        initialLng === FALLBACK_LNG ? Promise.resolve({}) : loadLanguage(FALLBACK_LNG),
    ]);

    i18n
        .use(initReactI18next)
        .init({
            lng: initialLng,
            fallbackLng: FALLBACK_LNG,
            supportedLngs: SUPPORTED_LNGS,
            interpolation: { escapeValue: false },
            react: { useSuspense: false },
            resources: {
                [initialLng]: { translation: detectedBundle },
                ...(fallbackBundle && Object.keys(fallbackBundle).length
                    ? { [FALLBACK_LNG]: { translation: fallbackBundle } }
                    : {}),
            },
            // Opcional: para ver logs en desarrollo
            debug: process.env.NODE_ENV === 'development',
        });

    // Log �til para verificar que el cambio ocurre
    i18n.on('languageChanged', (lng) => {
        console.log('[i18n] languageChanged =>', lng);
    });
};

initializeI18n();

export const changeLanguage = async (lng) => {
    if (!SUPPORTED_LNGS.includes(lng)) {
        console.warn(`[i18n] ${lng} no est� en supportedLngs:`, SUPPORTED_LNGS);
        return;
    }
    const translations = await loadLanguage(lng);
    i18n.addResourceBundle(lng, 'translation', translations, true, true);
    await i18n.changeLanguage(lng);
};

export default i18n;
